import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import './StaffTableRow.css';
import { useSelector } from 'react-redux';

const StaffTableRow = ({ officer, stageColumns, handlePageChange, branchApplicationFilters, setBranchApplicationFilters }) => {
    const { officerProfile } = useSelector((store) => {
        return {
            officerProfile: store.UserReducer.officerProfile,
        }
    });

    const navigate = useNavigate();
    const location = useLocation();

    const storedFilters = JSON.parse(sessionStorage.getItem("branchApplicationFilters"));
    const storedBranchwiseAppFilters = JSON.parse(sessionStorage.getItem("bwApplicationListFilters"));

    let primaryBranch = officer?.branch_name === officerProfile?.branch?.branch_name;

    console.log({primaryBranch});

  return (
    <>
        <td className='staff-member'>
            <span>{officer?.officer_name}</span>
            <span>{officer?.emp_id}</span>
        </td>
        <td>
            <span className={`role-tag ${officer?.role_code?.toLowerCase()}-tag`}>{officer?.role_code}</span>
        </td>
        <td>
            <span className={`branch-tag ${primaryBranch ? 'primary-tag' : 'secondary-tag'}`}>{officer?.branch_name}</span>
        </td>
        <td>
            <span className="stage-count total">{officer?.total}</span>
        </td>
        {
            stageColumns?.map((stage) => {
                let stageCount = officer?.stage_breakdown?.[stage.key]?.count;
                // The Expired stage is sparse in stage_breakdown like every
                // other stage (no entry when an officer has none), but should
                // always render "0" here rather than a blank cell.
                if (stage.key === "expired" && (stageCount === undefined || stageCount === null)) {
                    stageCount = 0;
                }
                return (
                    (stageCount > 0) ?
                        <td
                            key={stage.key}
                            onClick={() => {
                                // console.log({ stageLabel:stage.label, stageKey: stage.key  });
                                // stageCount
                                let filter = {
                                    // ...storedFilters,
                                    current_application_bucket: stage.label,
                                    branch_code: storedBranchwiseAppFilters?.branch_code || "",
                                    ...(officer?.role_code === "RO"
                                    ? { ro_employee_ids: [officer?.emp_id] }
                                    : officer?.role_code === "BM"
                                    ? { bm_employee_ids: [officer?.emp_id] }
                                    : officer?.role_code === "BCM"
                                    ? { bcm_employee_ids: [officer?.emp_id] }
                                    : { ro_employee_ids: [officer?.emp_id] })
                                }

                                setBranchApplicationFilters(filter);

                                sessionStorage.setItem("branchApplicationFilters", JSON.stringify(filter));
                                handlePageChange(1);
                                // navigate("/branch-dashboard", { state: { from: location.pathname } });
                                navigate("/team-overview?tab=application-view", { state: { from: location.pathname } });
                            }}
                        >
                            <span className={`stage-count clickable ${stage.key}`}>{stageCount}</span>
                        </td> : 
                        <td 
                            key={stage.key} 
                        >
                            <span className={`stage-count not-clickable ${stage.key}`}>{stageCount}</span>
                        </td>
                )
            })
        }
    </>
  )
}

export default StaffTableRow